export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_TIME_ZONE_FORMAT = 'America/Vancouver';
export const TEXT_DATE_FORMAT = 'PPp';
export const TEXT_DATE_FORMAT_NO_TIME = 'PP';

export const DEFAULT_POLLING_INTERVAL = 3000;
